import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';
import TratosService from '../../services/tratos.service';
import PreTicketsService from '../../services/preTickets.service';

const SelectTicketXServicio = ({id, value, onChange, isInvalid, isClearable, disabled, filtro}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        if(filtro){
            PreTicketsService.searchInfoServicio(filtro).then((response) => {
                const newOptions = response.map((item) => {
                    return {
                        value: item.id_tk,
                        label: `#${item.id_tk} - ${item.titulo_tk}`
                    };
                });
                setOptions(newOptions);
                if (typeof value === 'string' || typeof value === 'number') {
                    setSelectedValue(
                        newOptions.find((opt) => opt.value === Number(value))
                    );
                } else if(Array.isArray(value)){
                    setSelectedValue(value.map(va=>({label:`#${va.id_tk} - ${va.titulo_tk}`,value:va.id_tk})));
                }else{
                    setSelectedValue(null)
                }
            });
        }
    }, [filtro]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            borderRadius: 8,
            boxShadow: isDarkMode 
                ? '0 4px 20px rgba(0, 0, 0, 0.3)' 
                : '0 4px 20px rgba(0, 0, 0, 0.1)',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? '#fff' 
                : isDarkMode ? '#e0e0e0' : '#000',
            background: state.isSelected 
                ? '#0364ff' 
                : state.isFocused 
                    ? isDarkMode ? '#3d4a62' : '#f0f7ff'
                    : isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#e8f1ff',
                color: isDarkMode ? '#90caf9' : '#0247B5',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#3d4a62' : '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#64B5F6' : '#02378c',
                color: '#fff',
            },
        }),
        control: (styles, state) => ({
            ...styles,
            borderRadius: 7,
            borderColor: state.isFocused 
                ? (isDarkMode ? '#64B5F6' : '#0364ff')
                : (isDarkMode ? '#3d4a62' : 'gray'),
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            boxShadow: state.isFocused 
                ? (isDarkMode ? '0 0 0 1px #64B5F6' : '0 0 0 1px #0364ff')
                : 'none',
            '&:hover': {
                borderColor: isDarkMode ? '#64B5F6' : '#0364ff',
            },
        }),
        singleValue: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (styles) => ({
            ...styles,
            color: isDarkMode ? '#b0bec5' : '#999',
        }),
    }), [isDarkMode])
    return (
        <Select
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            isDisabled={disabled}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectTicketXServicio.defaultProps = {
    isClearable: false
};

export default SelectTicketXServicio;
